import { useCallback, useEffect, useState } from 'react';
import { IoScan } from 'react-icons/io5';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';
import api from '@src/services/api';
import FaceId from '../../../../assets/images/icons/face-id.svg';

export default function SendDocumentsOnboarding() {
  const [data, setData] = useState<any>(null);
  const [modal, setModal] = useState(false);
  const [typeDocument, setTypeDocument] = useState('cpf');
  const location = useLocation();
  const history = useHistory();
  const toggle = () => setModal(!modal);

  const handleDate = () => {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  };

  const handleNow = () => {
    handleLater();
    history.push('/pages/account-settings?tab=3');
  };

  const handleLater = () => {
    localStorage.setItem('verifyDocumentary', handleDate());
    setModal(false);
  };

  const handleVerifyUserData = useCallback(async () => {
    const userData = localStorage.getItem('userData');
    const verifyDocumentary = localStorage.getItem('verifyDocumentary');
    if (userData) {
      const data = JSON.parse(userData);
      setData(data);
      const accessToken = data?.accessToken;
      const payloadBase64 = accessToken.split('.')[1];
      const payload = JSON.parse(atob(payloadBase64));
      const expTimestamp = payload.exp;
      const currentTimestamp = Math.floor(Date.now() / 1000);

      const res = await api.get('/system/');

      const checkEnable2fa = res.data.filter((e: any) => {
        if (e.function_name === 'two_factor_authentication' && e.status === 1) {
          return true;
        }
      });

      setTypeDocument(data.company?.typeDocument);

      // if (currentTimestamp > expTimestamp) {
      //   return;
      // }

      // if (data.isTheSupport === true) {
      //   return;
      // }

      // if (data.verify_documents === 1) {
      //   return;
      // }

      // if (data.two_factor_authentication === 0) {
      //   if (checkEnable2fa.length >= 1) {
      //     return;
      //   }
      // }

      // history.push('/verify/documentary');
    }
  }, []);

  useEffect(() => {
    handleVerifyUserData();
  }, [location.pathname, handleVerifyUserData]);

  return (
    <div>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        scrollable
        centered
        backdrop="static"
      >
        <ModalHeader>
          <span className="text-danger">Atenção</span>
        </ModalHeader>
        <ModalBody>
          <Row className="mb-2">
            <Col sm="12" className="d-flex justify-content-center">
              <h2>Verificação Documental</h2>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col sm="12" className="d-flex justify-content-center">
              <img src={FaceId} alt="ScanFace" width={150} height={150} />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col sm="12">Precisamos que nos envie os seguintes documentos</Col>
          </Row>
          <Row className="mb-2">
            <Col sm="12">
              <div>
                <li>Foto do rosto</li>
                <li>
                  Documento com foto <strong>RG</strong> ou <strong>CNH</strong>
                </li>
                <li>Comprovante de endereço</li>
                <li>
                  Comprovante bancário{' '}
                  {typeDocument === 'cnpj' ? 'da empresa' : ''}
                </li>
                {typeDocument === 'cnpj' ? (
                  <>
                    <li>Cartão CNPJ</li>
                    <li>Contrato Social</li>
                  </>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <h6>Aviso:</h6>
              <div>
                Os documentos solicitados são{' '}
                <strong className="font-italic">obrigatórios</strong> e devem
                ser enviado para que você utilize os recursos do{' '}
                <strong className="font-italic">sistema</strong>, a falta dos
                documentos limitará algumas ações.
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleNow}>
            Enviar agora
          </Button>{' '}
          <Button color="secondary" onClick={handleLater}>
            Mais tarde
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
